import { escapeReferenceToken } from '@criteria/json-pointer'
import { Operation as OperationV3_0 } from '@criteria/openapi/v3.0'
import { Operation as OperationV3_1 } from '@criteria/openapi/v3.1'
import { Change, OpenAPI } from './Change'
import { AddOperation, DeleteOperation, Method, Operation } from './operation'

export class AddEndpoint extends Change {
  constructor(
    readonly path: `/${string}`,
    readonly method: Method,
    readonly resourceName: string | null,
    readonly descriptor?: {
      summary?: string
      description?: string
    }
  ) {
    super()
  }

  apply(document: OpenAPI): void {
    const changes: Change[] = []

    let value: Operation
    if (document.openapi.startsWith('3.1.')) {
      const operation: OperationV3_1<never> = {}
      value = operation
    } else {
      const operation: OperationV3_0<never> = {
        responses: {}
      }
      value = operation
    }
    if (this.resourceName) {
      value.tags = [this.resourceName]
    }
    if (this.descriptor?.summary) {
      value.summary = this.descriptor.summary
    }
    if (this.descriptor?.description) {
      value.description = this.descriptor.description
    }
    changes.push(new AddOperation(`#/paths/${escapeReferenceToken(this.path)}/${this.method}`, value))

    changes.forEach((change) => change.apply(document))
  }
}

export class DeleteEndpoint extends Change {
  constructor(readonly path: `/${string}`, readonly method: Method) {
    super()
  }

  apply(document: OpenAPI): void {
    const changes: Change[] = []

    changes.push(new DeleteOperation(`#/paths/${escapeReferenceToken(this.path)}/${this.method}`))

    changes.forEach((change) => change.apply(document))
  }
}
